import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WorkorderService {
  serviceType: string;
  constructor(private http: HttpClient) { }

  dataUrl = `${environment.baseUrl}api/vendorSearch/`;
  woDataUrl = `${environment.baseUrlForAxlePoint}api/alxepoint/workorder/`;
  vendorRecords: any;

  headerData = {
    "token": 'TTNFleet2018',
  };
  reqHeader = new HttpHeaders(this.headerData);

  getWOServiceTypes(): Observable<any> {
    return this.http.get<any>(`${this.dataUrl}GetVendorServiceSearch`);
  }

  getWOSubServiceTypes(serviceID: number): Observable<any> {
    return this.http.get<any>(`${this.dataUrl}GetVendorSubServiceSearch/${serviceID}`);
  }

  getWoStatuses(): Observable<any> {
    return this.http.get<any>(`${this.woDataUrl}WoStatuses`, { headers: this.reqHeader });
  }

  getCompanyStates(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrlForAxlePoint}getStates`, { headers: this.reqHeader });
  }

  getBreakdownCity(city: number): Observable<any> {
    return this.http.get<any>(`${this.woDataUrl}getCityAutoSuggest/${city}`, { headers: this.reqHeader });
  }

  getVendorList(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrlForAxlePoint}getVendorList`);
  }

  getWOsFromWOSearch(getWo): Observable<any> {
    return this.http.post(`${this.woDataUrl}WOsFromWOSearch`, getWo, { headers: this.reqHeader });
  }

  getWorkOrdersForEventChange(getWoEvent): Observable<any> {
    return this.http.post(`${this.woDataUrl}getWorkOrdersForEventChange`, getWoEvent, { headers: this.reqHeader });
  }

  setVendorRecords(vendorRecords){
    this.vendorRecords = vendorRecords;
  }
  getVendorRecords(){
    return this.vendorRecords;
  }
}
